module.exports = __webpack_public_path__ + "img/6.4da72e0.png";